<template>
  <div>
    <!-- description -->
    <label for="description" class="mb-u4"> Description </label>

    <base-text-editor
      id="description"
      ref="input__description"
      v-model="form.description"
      name="description"
      class="input__description"
      :disabled="isSaving"
      :editor-options="editorOptions"
    ></base-text-editor>

    <!-- button -->
    <div class="divider mt-u17" />
    <div class="d-flex mt-u4">
      <b-button variant="success" :disabled="isSaving" @click="save">
        <b-spinner v-if="isSaving" style="width: 1rem; height: 1rem" />
        <div v-else>Save</div>
      </b-button>
      <b-button variant="link" class="ml-u1" @click="goToPreviousPage">
        Back to previous page
      </b-button>
    </div>
  </div>
</template>

<script>
import BaseTextEditor from '../base-components/BaseTextEditor';

export default {
  components: {
    BaseTextEditor
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        description: ''
      })
    },
    isSaving: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: {
        description: ''
      },
      editorOptions: {
        // modules: {
        //   toolbar: [
        //     "bold",
        //     "italic",
        //     "underline",
        //     { header: 1 },
        //     { header: 2 },
        //     { list: "ordered" },
        //     { list: "bullet" },
        //     "link",
        //   ],
        // },
        placeholder: 'Insert your assessment instruction'
      }
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    init() {
      this.form.description = this.data.description;
    },

    async save() {
      this.$emit('save', this.form);
    },

    async cancel() {
      this.$emit('cancel');
    },

    goToPreviousPage() {
      if (this.$route.query.previousPath) {
        const { previousPath } = this.$route.query;

        this.$router.push({ path: previousPath });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style></style>
